import { Link } from 'react-router-dom';
import { Panel } from '../components/primitives';

export function NotFound(): JSX.Element {
  return (
    <Panel title="Page not found" subtitle="unknown route">
      <p className="text-muted" style={{ margin: 0 }}>
        That route does not exist in this dashboard. The seven pages of §3.2 are listed in the sidebar, starting with{' '}
        <Link to="/">Live overview</Link>.
      </p>
    </Panel>
  );
}
